import { BASE_URL } from "./variables";

export const saveUser = async (userData) => {
  try {
    console.log('saveUser: payload=', userData);
    
    // Use business auth token if available, otherwise use default token
    const businessToken = localStorage.getItem('businessAuthToken');
    const authToken = businessToken || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImJ1c2luZXNzSWQiOjEsIk1lbWJlcklEIjoxLCJ1c2VybmFtZSI6ImFkbWluIiwiZmlyc3ROYW1lIjoiQWRtaW5pc3RyYXRvciIsImxhc3ROYW1lIjoiQW5rb3RhIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.AxVVChn_pG_7u8Btwjn_4TMiIu22Tvf9cSIqQKGHeOU';
    
    const res = await fetch(`${BASE_URL}/save-user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify(userData)
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      console.error(`saveUser: HTTP ${res.status}`, text);
      throw new Error(`saveUser failed: ${res.status}`);
    }

    const data = await res.json().catch(() => null);
    console.log('saveUser: response=', data);
    return data;
  } catch (error) {
    console.error('Error in saveUser:', error);
    throw error;
  }
};

export default saveUser;
